import React, { useContext } from "react";
import { AssessmentInfoContext } from "../../../../../provider/CareRecipientConfigAssessmentInfoProvider";
import { Button } from "../../../../common/button/Button";

export const DetailSaveButton = React.memo(function DetailSaveButton() {
    const { handleAssessmentUpdateClicked } = useContext(AssessmentInfoContext);

    return (
        <div className={"button_area"}>
            <Button label={"変更内容を反映する"} onClick={handleAssessmentUpdateClicked} />
        </div>
    );
});